import React from 'react';
import { Helmet } from 'react-helmet-async';

const CookiesPolicy = () => (
  <>
    <Helmet>
      <title>Cookies Policy | nautdigital</title>
      <meta name="description" content="Learn about how nautdigital uses cookies and similar technologies on our website." />
    </Helmet>
    <div className="container mx-auto py-16 px-4 min-h-screen">
      <h1 className="text-3xl font-bold text-white mb-6">Cookies Policy</h1>
      <p className="text-gray-300 mb-4">
        This Cookies Policy explains how nautdigital uses cookies and similar tracking technologies when you visit our website. By using our website, you consent to the use of cookies as described in this policy.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">What Are Cookies?</h2>
      <p className="text-gray-300 mb-4">
        Cookies are small text files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">How We Use Cookies</h2>
      <p className="text-gray-300 mb-4">We use cookies for the following purposes:</p>
      <ul className="list-disc list-inside text-gray-300 mb-4">
        <li><strong>Essential Cookies:</strong> These cookies are necessary for the website to function properly. They enable core functionality such as security, network management, and accessibility.</li>
        <li><strong>Analytics Cookies:</strong> These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. We use this data to improve our website's performance and user experience.</li>
        <li><strong>Preference Cookies:</strong> These cookies allow the website to remember choices you make (such as your cookie consent preferences) and provide enhanced, more personalized features.</li>
      </ul>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">Third-Party Cookies</h2>
      <p className="text-gray-300 mb-4">
        We may use third-party services such as Google Analytics to analyze website traffic and usage patterns. These third parties may place cookies on your device to collect information on our behalf. These third-party cookies are governed by the respective privacy policies of these external services.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">Managing Cookies</h2>
      <p className="text-gray-300 mb-4">
        You can control and manage cookies in various ways. Please note that removing or blocking cookies may impact your user experience and some functionality may no longer be available.
      </p>
      <ul className="list-disc list-inside text-gray-300 mb-4">
        <li><strong>Browser Settings:</strong> Most browsers allow you to refuse or accept cookies, delete existing cookies, and set preferences for certain websites. Check your browser's help section for instructions.</li>
        <li><strong>Cookie Consent Banner:</strong> When you first visit our website, you can choose which types of cookies to accept through our cookie consent banner.</li>
        <li><strong>Opt-Out Tools:</strong> You can opt out of Google Analytics tracking by installing the <a href="https://tools.google.com/dlpage/gaoptout" className="text-accent hover:underline" target="_blank" rel="noopener noreferrer">Google Analytics Opt-out Browser Add-on</a>.</li>
      </ul>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">Changes to This Policy</h2>
      <p className="text-gray-300 mb-4">
        We may update this Cookies Policy from time to time to reflect changes in technology, legislation, or our business practices. We encourage you to review this page periodically for the latest information.
      </p>

      <h2 className="text-xl font-semibold text-white mb-2 mt-6">Contact Us</h2>
      <p className="text-gray-300 mb-2">
        If you have any questions about our use of cookies, please contact us using the <a href="/contact#contact" className="text-accent hover:underline">Contact Page</a>.
      </p>
      <p className="text-gray-300">nautdigital, London, UK</p>
      <p className="text-gray-500 text-xs mt-8">Last updated: {new Date().toLocaleDateString()}</p>
    </div>
  </>
);

export default CookiesPolicy;
